import type { CrmEstagio } from "@/types/crm";

export type CrmView = "home" | "inbox" | "kanban" | "campanhas";

export function iniciais(nome?: string | null, telefone?: string) {
  if (nome && nome.trim()) {
    return nome
      .trim()
      .split(" ")
      .slice(0, 2)
      .map((p) => p[0])
      .join("")
      .toUpperCase();
  }
  return telefone?.slice(-2) ?? "?";
}

export function formatHora(iso?: string | null) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDataHora(iso?: string | null) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatTelefone(tel?: string | null) {
  if (!tel) return "—";
  const d = tel.replace(/\D/g, "");
  if (d.length === 13 && d.startsWith("55")) {
    return `+55 (${d.slice(2, 4)}) ${d.slice(4, 9)}-${d.slice(9)}`;
  }
  return tel;
}

export const FILA_ESTAGIOS: CrmEstagio[] = ["novo", "aguardando_resposta"];
